import {
  AppBar,
  Box,
  CssBaseline,
  Grid,
  Paper,
  Toolbar,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import championshipLogo from 'assets/images/championship-logo.png';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  toolbarStyle: {
    paddingRight: theme.spacing(3),
    paddingLeft: 0,
    height: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center'
  },
  logo: { width: theme.spacing(20), alignSelf: 'center' },
  container: {
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(4)
  },
  card: { backgroundColor: theme.palette.common.white, },
  cardTitle: {
    fontWeight: 500,
    padding: theme.spacing(2),
    color: theme.palette.primary.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.accent.main,
    paddingBottom: theme.spacing(2)
  },
}));

type DocumentRequestPanelProps = {
  title: string
  children?: React.ReactNode
}

// Logo app bar + titled card shared by the confirm, message and upload states.
export const DocumentRequestPanel: FC<DocumentRequestPanelProps> = ({ title, children }) => {
  const classes = useStyles();
  return (
    <Grid>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar className={classes.toolbarStyle}>
          <img src={championshipLogo} alt="logo" className={classes.logo} />
        </Toolbar>
      </AppBar>
      <Grid container justifyContent="center" className={classes.container}>
        <Box display="flex" flexDirection="column" style={{ width: '70%' }}>
          <Paper className={classes.card}>
            <Typography variant="h5" className={classes.cardTitle}>
              {title}
            </Typography>
            {children}
          </Paper>
        </Box>
      </Grid>
    </Grid>
  );
};
